import Service, { service } from '@ember/service'
import { formatISO, parseISO, startOfDay, endOfMonth, startOfMonth, type NormalizedInterval, endOfDay } from 'date-fns'
import { tracked } from '@glimmer/tracking'
import getAcademicYear from 'district-ui-client/utils/dates/get-academic-year'
import type SessionService from 'district-ui-client/services/session'

/**
 * A service for storing and accessing a date range across an app
 */
export default class DateFilterService extends Service {
  @service session!: SessionService

  /**
   * The date range reperesented as a string, '2020-01-01:2020-01-31'
   */
  @tracked dateRange = ''

  /**
   * The period represented by the set date range.
   */
  get period(): NormalizedInterval {
    const [fromStr, toStr] = this.dateRange.split(':')

    if (fromStr && toStr) {
      return { start: startOfDay(parseISO(fromStr)), end: endOfDay(parseISO(toStr)) }
    }

    return this.thisAcademicPeriod
  }

  toDateRange({ start, end }: NormalizedInterval) {
    return `${formatISO(start, { representation: 'date' })}:${formatISO(end, { representation: 'date' })}`
  }

  get thisAcademicPeriod(): NormalizedInterval {
    return getAcademicYear(new Date(), this.session.currentDisco.countryCode)
  }

  get thisMonth(): NormalizedInterval {
    return { start: startOfMonth(new Date()), end: endOfMonth(new Date()) }
  }
}

declare module '@ember/service' {
  interface Registry {
    'date-filter': DateFilterService
  }
}
